export default __webpack_public_path__ + "static/media/icono2.db07aa89.svg";